import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import { RequestAccessButton } from "./RequestAccessButton";

const STEPS = [
    { step: "1st step", text: "Customize the metrics for your needs" },
    { step: "2nd step", text: "Ingest your data and compare it to market" },
    { step: "3rd step", text: "Drive the performance up, based on data driven analytics" },
];

export const RequestAccessBanner = ({ className }) => (
    <div className={cn("flex w-full flex-col", className)}>
        <div className="flex flex-col gap-4 rounded-t-[6px] border border-cm-p-outline-variation bg-cm-p-surface px-6 py-4 md:flex-row md:items-center">
            <div className="flex flex-1 flex-col">
                <h2 className="text-xl font-medium text-cm-p-text-primary">
                    <TranslatedText>Tell us the metric your operation actually runs on</TranslatedText>
                </h2>
                <TranslatedText className="text-sm text-cm-p-text-secondary">
                    You are looking at Analytics with sample data, but any metric you can define, benchmarked against market can be shown
                    here.
                </TranslatedText>
            </div>
            <RequestAccessButton />
        </div>
        <div className="flex flex-col gap-4 rounded-b-[6px] border border-t-0 border-cm-p-outline-variation bg-cm-p-surface-hover px-6 py-4 md:flex-row md:justify-between md:gap-8">
            {STEPS.map(({ step, text }) => (
                <div key={step} className="flex flex-col text-sm font-medium">
                    <TranslatedText className="text-cm-p-accent-600">{step}</TranslatedText>
                    <TranslatedText className="text-cm-p-text-primary">{text}</TranslatedText>
                </div>
            ))}
        </div>
    </div>
);
